<template>
  <div  :style="{'background-image':`url(${backgroundImageUrl})`}" class="section-wrapper">
    <div class="sec7-trigger"></div>
    <img :src="imageUrl" class="sec7-img" />
    <div  :style="{'background-image':`url(${polaroidImageUrl})`}" class="sec-7-polaroid-photo"></div>
  </div>
</template>

<script>

export default {
  computed: {

    backgroundImageUrl: function() {
      return window.pageContentData.params.images["img-sec-7-bg"];
    },
     polaroidImageUrl: function() {
      return window.pageContentData.params.images["img-sec-7-polaroid"];
     },
         imageUrl: function() {
      return window.pageContentData.params.images["img-sec-7-oven"];
    }
   
  },
 
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100%;
  height: 36.45vw;
  min-height: 300px;
  max-height: 690px;
  position: relative;
  align-items: center;
  padding: 0rem 0 4rem;
  display: flex;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 2;

  @media only screen and (max-width: 1024px) {
    // min-height: auto;
    // height: auto;
    // padding: 4rem 0;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 2rem 0;
  }
  .sec7-trigger{
    position: absolute;
    bottom:-50px;
  
  }
  .sec7-img {
    display: flex;
    width: 20vw;
    height: auto;
    position: absolute;
    bottom: -27%;
    left: 5%;
    z-index: 2;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
  .sec-7-polaroid-photo {
    display: flex;
    position: absolute;
    width: 35vw;
    height: 45%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    top: 8%;
    left: 22%;

    @media only screen and (max-width: 768px) {
      width: 40vw;
      left: 18%;
    }
    @media only screen and (max-width: 588px) {
      width: 50vw;
      left: 12%;
    }
    @media only screen and (max-width: 480px) {
      width: 65vw;
      left: 2%;
    }
  }
}
</style>
